import type { SVGProps } from "react";
export const Favorite = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M12 20.3267L10.8963 19.3345C9.23858 17.8307 7.86775 16.5384 6.78375 15.4577C5.69975 14.3769 4.84075 13.415 4.20675 12.572C3.57275 11.7292 3.12983 10.9602 2.878 10.2652C2.626 9.57041 2.5 8.86533 2.5 8.14999C2.5 6.73083 2.9785 5.54266 3.9355 4.58549C4.89267 3.62849 6.08083 3.14999 7.5 3.14999C8.373 3.14999 9.198 3.35416 9.975 3.76249C10.752 4.17083 11.427 4.75641 12 5.51924C12.573 4.75641 13.248 4.17083 14.025 3.76249C14.802 3.35416 15.627 3.14999 16.5 3.14999C17.9192 3.14999 19.1073 3.62849 20.0645 4.58549C21.0215 5.54266 21.5 6.73083 21.5 8.14999C21.5 8.86533 21.374 9.57041 21.122 10.2652C20.8702 10.9602 20.4272 11.7292 19.7932 12.572C19.1592 13.415 18.3018 14.3769 17.221 15.4577C16.1403 16.5384 14.7679 17.8307 13.1038 19.3345L12 20.3267Z"
			fill="currentColor"
		/>
	</svg>
);
